import { IdName, NameDisplayName, ActionButton } from '../dtos/Common.dto';


// RoleAccessEnum, RoleDTO

// Use that

export enum RoleAccessEnum {
  SYSTEM = 1,
  STUDY = 2,
  SITE = 3
}

export interface RoleDTO {
  id?: number;
  name: string;
  platforms: string[];
  accessLevel: RoleAccessEnum;
  code: string;
  isStudyTeam: boolean;
  isDefault: boolean;
  // baseRoleId: number;
}

export interface RoleDisplay {
  id?: number;
  name?: string;
  platforms?: string[];
  accessLevel?: number;
  isStudyTeam?: boolean;
  isDefault?: boolean;
}

export type Role = IdName;


export interface RoleFilterParams {
  roles?: number[];
  platforms?: string[];
}

export interface RolePopupData {
  roleData: RoleDTO | null;
  roleList: IdName[];
  platformList: NameDisplayName[];
}


/* =====================================
   ROLE UI-SPECIFIC INTERFACES
===================================== */

export interface RoleModalResult {
  success: boolean;
  data?: RoleDTO;
  action?: 'create' | 'update' | 'delete';
}

export interface ActionEvent {
  action: string;
  row: RoleTableRow;
}


export interface RoleTableRow {
  SrNo: number;
  'Role Name': string;
  Platform: string;
  Action: string;
  _original: RoleDTO
}

/* =====================================
   ROLE BUSINESS CONSTANTS
===================================== */
export const ROLE_TITLE = 'Roles';

/* =====================================
   ROLE TABLE CONFIGURATION CONSTANTS
===================================== */
export const ROLE_COLUMN_LIST = ['SrNo', 'Role Name', 'Platform', 'Action'];

export const ROLE_ACTION_BUTTONS: ActionButton[] = [
  { show: true, title: 'Edit', iconClass: 'updateIcon', testId: 'btn-edit', action: 'edit' },
  { show: true, title: 'Delete', iconClass: 'deleteIcon', testId: 'btn-delete', action: 'delete' }
];

export const ROLE_EXCLUDED_KEYS = new Set(['_original']);

/* =====================================
   Role PAGE UI INTERFACES
===================================== */
export interface RolePageUI {
  buttons: {
    addRole: string;
    cancel: string;
    delete: string;
  };
  tooltips: {
    hideFilter: string;
    filterSearch: string;
  };
  icons: {
    hideFilter: string;
    showFilter: string;
  };
  dialogs: {
    deleteDialog: {
      title: string;
      message: string;
    }
  }
}

/* =====================================
   ROLE PAGE UI CONSTANTS
===================================== */
export const ROLE_PAGE_UI: RolePageUI = {
  buttons: {
    addRole: 'Add Role',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  tooltips: {
    hideFilter: 'Hide Filter',
    filterSearch: 'Filter Search',
  },
  icons: {
    hideFilter: 'hideFilterIcon',
    showFilter: 'showFilterIcon'
  },
  dialogs: {
    deleteDialog: {
      title: 'Delete Role',
      message: 'Are you sure you want to delete this role?'
    }
  }
};


/* =====================================
   ROLE FORM CONFIGURATION CONSTANTS
===================================== */
export enum RoleAccessLevel {
  SYSTEM = 'SYSTEM',
  STUDY = 'STUDY',
  SITE = 'SITE'
}